module.exports = __webpack_public_path__ + "static/media/fitness-training.c3fac503.svg";